/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePopupConfigReqVo
 */
export interface CreatePopupConfigReqVo {
    /**
     * 横坐标
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    xCoordinate: number;
    /**
     * 纵坐标
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    yCoordinate: number;
    /**
     * 标题
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    title: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    content: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    contentCn: string;
    /**
     * 开始日期
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    beginDate: string;
    /**
     * 结束日期
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    endDate: string;
    /**
     * 宽度
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    width?: number;
    /**
     * 高度
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    height?: number;
    /**
     * 是否居中：0-不居中，1-居中
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    center?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    enable: number;
    /**
     * 链接地址
     * @type {string}
     * @memberof CreatePopupConfigReqVo
     */
    url?: string;
    /**
     * 是否显示：0-不显示，1-显示
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    show: number;
    /**
     * 是否当前窗口打开：0-不在当前窗口，1-在当前窗口
     * @type {number}
     * @memberof CreatePopupConfigReqVo
     */
    selfWindow: number;
}

/**
 * Check if a given object implements the CreatePopupConfigReqVo interface.
 */
export function instanceOfCreatePopupConfigReqVo(value: object): value is CreatePopupConfigReqVo {
    if (!('xCoordinate' in value) || value['xCoordinate'] === undefined) return false;
    if (!('yCoordinate' in value) || value['yCoordinate'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('contentCn' in value) || value['contentCn'] === undefined) return false;
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('show' in value) || value['show'] === undefined) return false;
    if (!('selfWindow' in value) || value['selfWindow'] === undefined) return false;
    return true;
}

export function CreatePopupConfigReqVoFromJSON(json: any): CreatePopupConfigReqVo {
    return CreatePopupConfigReqVoFromJSONTyped(json, false);
}

export function CreatePopupConfigReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePopupConfigReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'xCoordinate': json['xCoordinate'],
        'yCoordinate': json['yCoordinate'],
        'title': json['title'],
        'content': json['content'],
        'contentCn': json['contentCn'],
        'beginDate': json['beginDate'],
        'endDate': json['endDate'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'center': json['center'] == null ? undefined : json['center'],
        'enable': json['enable'],
        'url': json['url'] == null ? undefined : json['url'],
        'show': json['show'],
        'selfWindow': json['selfWindow'],
    };
}

export function CreatePopupConfigReqVoToJSON(json: any): CreatePopupConfigReqVo {
    return CreatePopupConfigReqVoToJSONTyped(json, false);
}

export function CreatePopupConfigReqVoToJSONTyped(value?: CreatePopupConfigReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xCoordinate': value['xCoordinate'],
        'yCoordinate': value['yCoordinate'],
        'title': value['title'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'beginDate': value['beginDate'],
        'endDate': value['endDate'],
        'width': value['width'],
        'height': value['height'],
        'center': value['center'],
        'enable': value['enable'],
        'url': value['url'],
        'show': value['show'],
        'selfWindow': value['selfWindow'],
    };
}

